import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import BalancoService from '../../../../services/balanco-auth';
import InfiniteScroll from '../../utils/infiniteScroll';
import Balanco from './balanco';


const ListarBalancos = () => {


    async function fetchBalancos() {
        await seraQueAcabou();
        const response = await BalancoService.listar({ limit: true, cod_balanco: cod });
        if (response.data.length >= 1) {
            let count = Math.floor(numBalancos / 20) + 1
           for (let i = 1; i < count; i++) {
                setBalancos([...balancos, ...response.data])
                setCod(response.data[response.data.length-1]["cod_balanco"])
                if (response.data.length < 20) {
                    setAindaTem(false)
                }
           }
        } else {
            setBalancos([])
            setVazio(true)
        }
    }
    
    const [balancos, setBalancos] = useState([]);
    const [ano, setAno] = useState(false);
    const [tipo, setTipo] = useState(false);
    const [fundo, setFundo] = useState(null);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [balanco, setBalanco] = useState("");
    const [cod, setCod] = useState(null);
    const [numBalancos, setNumBalancos] = useState(null);
    const [aindaTem, setAindaTem] = useState();



    async function fetchBalancosIn() {
        await pegaNumBalancos();
        const response = await BalancoService.listar({limit: true});
        if (response.data.length >= 1) {
            setBalancos(response.data)
            setVazio(false)
            setCod(response.data[response.data.length-1]["cod_balanco"])
            if (response.data.length == 20) {
                setAindaTem(true)
            } else {
                setAindaTem(false)
            }
        } else {
            setBalancos([])
            setVazio(true)
        }
    }

    async function pegaNumBalancos() {
        const response = await BalancoService.numBalancos({ todas: true })
        setNumBalancos(parseInt(response.data))
    }

    const seraQueAcabou = async () => {
        if (balancos.length >= numBalancos + 1) {
            setAindaTem(false)
        } else {
            setAindaTem(true)
        }
    }

    const handleEditar = (id) => {
        setBalanco(id);
        setEditar(true)
    }

    const handleTipo = (id) => {
        setBalanco(id);
        setTipo(true)
    }

    const handleAno = (id) => {
        setBalanco(id);
        setAno(true)
    }

    const handleFundo = (id) => {
        setBalanco(id);
        setFundo(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o balanço?')) {
            await BalancoService.deletar(id)
            alert("Balanço deletado com sucesso!")
            fetchBalancos();
        }
    }

    useEffect(() => {
        fetchBalancosIn();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/balanco/editar/${balanco}`} />
        )
    } else if (ano) {
        return (
            <Navigate to={`/restrito/balanco/ano/${balanco}`} />
        )
    } else if (tipo) {
        return (
            <Navigate to={`/restrito/balanco/tipo/${balanco}`} />
        )
    } else if (fundo) {
        return (
            <Navigate to={`/restrito/balanco/fundo/${balanco}`} />
        )
    } else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setBalancos={setBalancos}
                        setVazio={setVazio}
                        setAindaTem={setAindaTem}
                        fetchBalancosIn={fetchBalancosIn}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={3}>
                            {balancos.map((balanco, index) =>
                                <Balanco
                                    fetchBalancosIn={fetchBalancosIn}
                                    balanco={balanco}
                                    key={index}
                                    editar={handleEditar}
                                    fundo={handleFundo}
                                    tipo={handleTipo}
                                    ano={handleAno}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                        {aindaTem ?
                            <Fragment>
                                <p>Carregando mais balanços...</p>
                                <InfiniteScroll Listar={fetchBalancos} />
                            </Fragment>
                            : <p>Todos os balanços já foram exibidos :)</p>}
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarBalancos;